/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_Status_YesterdayInputs */

const en_source_status_yesterday = /** @type {(inputs: Source_Status_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yesterday`)
};

const nl_source_status_yesterday = /** @type {(inputs: Source_Status_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gisteren`)
};

/**
* | output |
* | --- |
* | "Yesterday" |
*
* @param {Source_Status_YesterdayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const source_status_yesterday = /** @type {((inputs?: Source_Status_YesterdayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_Status_YesterdayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_source_status_yesterday(inputs)
	return en_source_status_yesterday(inputs)
});